import { IonCard } from "@ionic/react";
import { ReactNode } from "react";

import styles from "@components/v1/labels/Tag.module.css";
import BodyCopy from "@components/v1/typography/BodyCopy";
import Icon from "@components/v2/icons/Icon";
import { Colors } from "@utils/colorUtils";
import { IconName } from "@utils/iconUtils";

export type TagProps = {
  children?: ReactNode;
  color: Colors;
  icon?: IconName;
  size?: "large";
  spacing?: boolean;
  text?: string;
  textColor?: Colors;
};

const Tag = ({ children, color, icon, size, spacing = false, text, textColor }: TagProps) => {
  const colorForText = textColor ? textColor : color === "gray-50" ? "gray-300" : "white";

  const wrapperStyles = [styles.tag];

  if (size === "large") {
    wrapperStyles.push(styles.largeTag);
  }

  if (spacing) {
    wrapperStyles.push(styles.spacing);
  }

  if (icon) {
    wrapperStyles.push(styles.withIcon);
  }

  if (color === "white") {
    wrapperStyles.push(styles.white);
  }

  return (
    <IonCard className={wrapperStyles.join(" ")} color={color}>
      {icon && (
        <span className={styles.icon}>
          <Icon color={colorForText} icon={icon} />
        </span>
      )}
      <BodyCopy bold color={colorForText} size="small">
        {children ?? text}
      </BodyCopy>
    </IonCard>
  );
};

export default Tag;
